// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { breakoutPlugin } from '@atlaskit/editor-plugin-breakout';
export type {
	BreakoutPlugin,
	BreakoutPluginOptions,
	BreakoutPluginState,
	BreakoutPluginDependencies,
} from '@atlaskit/editor-plugin-breakout';
